<template>
  <details class="ecom materials-accordion">
    <summary class="ecom materials-accordion__summary">
      <slot name="icon" class="ecom materials-accordion__icon"></slot>
      <slot name="header"></slot>
      <img class="ecom materials-accordion__arrow" :src="chevron" />
    </summary>
    <slot name="content"></slot>
  </details>
</template>

<script>
import config from '@/config'

const { cdn } = config
export default {
  data () {
    return {
      chevron: `${cdn}chevron-icon.svg`
    }
  }
}
</script>
